import { render, staticRenderFns } from "./ModalFormularioConceptoUniversidad.vue?vue&type=template&id=69d6a605"
import script from "./ModalFormularioConceptoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioConceptoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports